export const serializeParams = (params = {}) => {
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value === undefined || value === null)
            continue;
        const values = Array.isArray(value) ? value : [value];
        for (const item of values) {
            if (item === undefined || item === null)
                continue;
            if (item instanceof Date) {
                search.append(key, item.toISOString());
            }
            else if (typeof item === 'object') {
                search.append(key, JSON.stringify(item));
            }
            else {
                search.append(key, String(item));
            }
        }
    }
    return search.toString();
};
